import ApiService from './ApiService'


export async function apiPrepareSignIn(data) {
    return ApiService.fetchData({ url: '/v1/auth/signin/ready', method: 'post', data })
}

export async function apiSignIn(data) {
    return ApiService.fetchData({
        url: `/v1/auth/signin`,
        method: 'post',
        data,
    })
}

export async function apiSignUp(data) {
    return ApiService.fetchData({
        url: `/v1/auth/signup`,
        method: 'post',
        data,
    })
}

export async function apiSignOut(data) {
    return ApiService.fetchData({
        url: `/v1/auth/signout`,
        method: 'post',
        data,
    })
}

export async function apiForgotPassword(data) {
    return ApiService.fetchData({
        url: `/forgot-password`,
        method: 'post',
        data,
    })
}

export async function apiResetPassword(data) {
    return ApiService.fetchData({
        url: `/reset-password`,
        method: 'post',
        data,
    })
}

export async function apiAccountIdDupCheck(data) {
    return ApiService.fetchData({
        url: `/v1/auth/id-dup-check`,
        method: 'post',
        data,
    })
}
